import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostWipeSDZDataJobProps {
    token: string;
    email?: string;
}

export const postWipeSDZDataJob: MutationFunction<
    AxiosResponse<any>,
    PostWipeSDZDataJobProps
> = async (props: PostWipeSDZDataJobProps) => {
    const { token, email } = props;
    const headers = getDefaultHeaders(token);
    const resetSDZDataJobUrl = '/jobs/sdz/wipe';

    return axiosInstance().post(
        resetSDZDataJobUrl,
        {
            emailResultsTo: email ?? '',
        },
        withHeaders(headers)
    );
};

export const useWipeSDZDataJob = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostWipeSDZDataJobProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postWipeSDZDataJob, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to wipe sdz data';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
